import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const RiskAssessmentAssignView = loadView(
  'risk-assessment/RiskAssessmentAssignView',
);
const RiskAssessmentCddView = loadView('risk-assessment/RiskAssessmentCddView');
const RiskAssessmentDashboardView = loadView(
  'risk-assessment/RiskAssessmentDashboardView',
);
const RiskAssessmentDetailView = loadView(
  'risk-assessment/RiskAssessmentDetailView',
);
const RiskAssessmentEddView = loadView('risk-assessment/RiskAssessmentEddView');

const riskAssessmentRoute = {
  path: ROUTE.PATH.RISK_ASSESSMENT,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.RISK_ASSESSMENT,
      component: RiskAssessmentDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.RISK_ASSESSMENT_ASSIGN}/:id`,
      name: ROUTE.NAME.RISK_ASSESSMENT_ASSIGN,
      component: RiskAssessmentAssignView,
      props: (route) => ({ ...route.params }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.RISK_ASSESSMENT_CDD}/:id`,
      name: ROUTE.NAME.RISK_ASSESSMENT_CDD,
      component: RiskAssessmentCddView,
      props: (route) => ({ ...route.params, ...route.query }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: ROUTE.PATH.RISK_ASSESSMENT_DASHBOARD,
      name: ROUTE.NAME.RISK_ASSESSMENT_DASHBOARD,
      component: RiskAssessmentDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.RISK_ASSESSMENT_DETAIL}/:id`,
      name: ROUTE.NAME.RISK_ASSESSMENT_DETAIL,
      component: RiskAssessmentDetailView,
      props: (route) => ({ ...route.params }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.RISK_ASSESSMENT_EDD}/:id`,
      name: ROUTE.NAME.RISK_ASSESSMENT_EDD,
      component: RiskAssessmentEddView,
      props: (route) => ({ ...route.params, ...route.query }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
  ],
};

export default riskAssessmentRoute;
